import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { useNavigate } from 'react-router';
import { ROUTES } from '@constants/routes';
import { useCurrentUser } from '@hooks/user/useCurrentUser';
import { fetchMemoryKeys } from '@services/agentMemory';
import { MemoryKeyList } from '@features/AgentMemory/MemoryKeyList';
import { RegisterKeyForm } from '@features/AgentMemory/RegisterKeyForm';
import { MemoryKeyEditor } from '@features/AgentMemory/MemoryKeyEditor';

const PageWrapper = styled.div``;
const BodyWrapper = styled.div`
  padding: 24px;
`;

export const AgentMemoryAdmin = () => {
  const navigate = useNavigate();
  const user = useCurrentUser();

  const [loadingKeys, setLoadingKeys] = React.useState(true);
  const [keys, setKeys] = React.useState([]);
  const [viewingKey, setViewingKey] = React.useState(null);
  const [registeringKey, setRegisteringKey] = React.useState(false);

  const loadKeys = React.useCallback(async () => {
    setLoadingKeys(true);
    const result = await fetchMemoryKeys();
    if (result) setKeys(result);
    setLoadingKeys(false);
  }, []);

  React.useEffect(() => {
    loadKeys();
  }, [loadKeys]);

  const onGoBack = () => {
    if (viewingKey !== null) {
      setViewingKey(null);
    } else {
      navigate(ROUTES.home);
    }
  };

  const handleSaveSuccess = () => {
    loadKeys();
  };

  const handleRegisterSuccess = () => {
    setRegisteringKey(false);
    loadKeys();
  };

  const renderContent = () => {
    if (registeringKey) {
      return <RegisterKeyForm onCancel={() => setRegisteringKey(false)} onSuccess={handleRegisterSuccess} />;
    }

    if (viewingKey !== null) {
      return (
        <MemoryKeyEditor
          memoryKey={viewingKey}
          userId={user?.id}
          onGoBack={onGoBack}
          onSaveSuccess={handleSaveSuccess}
        />
      );
    }

    return (
      <MemoryKeyList
        keys={keys}
        loadingKeys={loadingKeys}
        onViewKey={setViewingKey}
        onRegisterKey={() => setRegisteringKey(true)}
        onGoBack={onGoBack}
      />
    );
  };

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <BodyWrapper>{renderContent()}</BodyWrapper>
      </Body>
    </PageWrapper>
  );
};

export default AgentMemoryAdmin;
